import { useMemo } from 'react';
import classes from '../ReportResult/OldReportResult.module.css';
import Feedback from '../ReportResult/Feedback';
import RealPlayRecordDataHelper from 'features/realplays/RealPlayRecordData.helper';
import RealPlayQualifiedDataHelper from 'features/realplays/RealPlayQualifiedData.helper';
import ImprovementGraph from '../ReportResult/ImprovementGraph';
import Ratings from '../ReportResult/Ratings';

const OldNewRealPlayRightSection = ({ isLoadingResponse }) => {
  const { assignment_uuid, selectedScenario } = RealPlayRecordDataHelper();
  const { rating_criteria, feedback, status_ai } = RealPlayQualifiedDataHelper();

  const overallRating = useMemo(() => {
    if (!rating_criteria || rating_criteria?.length === 0) return 0;
    const initialValue = 0;
    const sum = rating_criteria.reduce(
      (accumulator, currentValue) => accumulator + currentValue?.rating,
      initialValue
    );
    let avg = sum / rating_criteria?.length;

    return sum === 0 ? 0 : avg;
  }, [rating_criteria]);

  return (
    <div className={classes.right}>
      {/* Improvement*/}
      <ImprovementGraph
        assignment_uuid={assignment_uuid}
        response_uuid={selectedScenario?.response?.uuid}
        mode={'review'}
        overall={overallRating}
      />
      {/*Overall Feedback*/}
      <Feedback feedback={feedback} status_ai={status_ai} isLoadingResponse={isLoadingResponse} />
      {/* Ratings & Why You Got Them*/}
      <Ratings
        rating_criteria={rating_criteria}
        status_ai={status_ai}
        isLoadingResponse={isLoadingResponse}
      />
    </div>
  );
};
export default OldNewRealPlayRightSection;